// src/api/axiosInstance.js
import axios from 'axios';
import { debugLog } from '../utils/logging/debugLog';

const baseURL = process.env.REACT_APP_BACKEND_URL;

if (!baseURL) {
  console.warn('⚠️ No REACT_APP_BACKEND_URL set — requests will fail!');
}

const instance = axios.create({
  baseURL,
  withCredentials: true, // ✅ sends/receives HttpOnly cookie (daisy_jwt)
});

export default instance;